export default "__VITE_ASSET__BLuATmau__"